import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function latinAndDigitsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = /^[a-zA-Z0-9#$-]*$/.test(control.value);
    return valid ? null : { invalidCharacters: true };
  };
}
